import {ProRole} from 'PMT/entities/security';
import {SessionUtils} from 'PMT/utils';

/**
 * @param permission The permission to check. Example: 'booking.canEdit..'
 * @param proRole The permission will be checked for the given proRole. If null, we retrieve the
 * proRole set on the session.
 */
export function havePermission(permission: string,
    proRole: ProRole = null): boolean {
  let role: ProRole = null;

  if (_.isNull(proRole)) {
    /**
     * The role is attached to the account on ApiProAccount.getMeAccount()
     */
    const account = SessionUtils.getObjectFromSession('ACCOUNT');

    if (_.isNull(account)) {
      return false;
    }

    role = account.role;
  } else {
    role = proRole;
  }

  if (_.isNull(role) || _.isUndefined(role)) {
    return false;
  }

  try {
    const obj = permission.split('.').reduce((object, key) => {
      return object[key];
    }, role.permissions);

    /**
     * The permission is ok if the object equals true or is an object that contains child
     * permissions.
     */
    return !_.isUndefined(obj) && !_.isNull(obj) && obj !== false;
  } catch (e) {
    // do nothing
  }

  return false;
}